import * as types from "../types";
import axios from "axios";

axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.token;

const state = {};
const getters = {};
const mutations = {};

const actions = {
  [types.CLASSROOM_LIST]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(types.API_BASE_URL + "classroom/all", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.CLASSROOM_DETAIL]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(types.API_BASE_URL + "classroom/detail", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.CLASSROOM_CREATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "classroom/create", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.CLASSROOM_UPDATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "classroom/update", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  }, 

  [types.CLASSROOM_SUBJECT_LIST]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(types.API_BASE_URL + "classroom/subject/all", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.CLASSROOM_SUBJECT_CREATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "classroom/subject/create", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  }, 

  [types.CLASSROOM_SUBJECT_UPDATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "classroom/subject/update", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  }, 

  [types.CLASSROOM_TEACHER_UPLOAD]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "classroom/teacher/upload", payload, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.CLASSROOM_STUDENT_UPLOAD]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "classroom/student/upload", payload, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.CLASSROOM_SUBJECT_UNASSIGN]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "classroom/subject/unassign", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.CLASSROOM_TEACHER_UNASSIGN]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "classroom/teacher/unassign", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.CLASSROOM_STUDENT_UNASSIGN]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "classroom/student/unassign", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};
